import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { getAllMedicalBills } from "~/store/totalData/actions";

const MedicalBillPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/MedicalBill"
    ),
  loading: LoadableLoading
});
const MedicalBillPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/MedicalBill"
    ),
  loading: LoadableLoading
});

class DetectMedicalBill extends Component {
  componentDidMount() {
    this.props.getAllMedicalBills();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <MedicalBillPageMobile {...this.props} />
        ) : (
          <MedicalBillPageDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    totalData: { bookingList }
  } = state;
  return {
    device: type,
    bookingList
  };
};

const MedicalBillHelmet = withTitle({
  component: DetectMedicalBill,
  title: "Medpro | Phiếu khám bệnh"
});

export default connect(mapStateToProps, { getAllMedicalBills })(
  MedicalBillHelmet
);
